/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validators_Favicon_UrlInputs */

const en_validators_favicon_url = /** @type {(inputs: Validators_Favicon_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid favicon URL. (Valid favicon URLs usually end with .ico, .jpg, .jpeg, .png, .svg or .webp)`)
};

const de_validators_favicon_url = /** @type {(inputs: Validators_Favicon_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie eine gültige Favicon-URL ein. (Gültige Favicon-URLs enden normalerweise mit .ico, .jpg, .jpeg, .png, .svg oder .webp)`)
};

/**
* | output |
* | --- |
* | "Please enter a valid favicon URL. (Valid favicon URLs usually end with .ico, .jpg, .jpeg, .png, .svg or .webp)" |
*
* @param {Validators_Favicon_UrlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validators_favicon_url = /** @type {((inputs?: Validators_Favicon_UrlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validators_Favicon_UrlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validators_favicon_url(inputs)
	return de_validators_favicon_url(inputs)
});